import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { UserContext } from "../../context/UserContext";
import { Link } from "react-router-dom";

import CustomFieldText from "../../form/CustomFieldText";
import GenericModal from "../../_generic_modal";

import * as Helper from "../../form/form_inscription_helper";
import { Carousel } from "react-bootstrap";
import ChanceBlock from "./_chanceBlock";
import * as Pattern from "../../form/form_pattern_helper";

const MonCompte = () => {

  const { t } = useTranslation();

  //Context user
  const { user, logout, login } = useContext(UserContext)

  //Handle password form
  const { register, handleSubmit, formState: { errors }, reset } = useForm()
  const submitRef = useRef(null)

  //Handle personnal data form
  const { register: registerP, handleSubmit: handleSubmitP, formState: { errors: errorsP }, reset: resetP } = useForm()
  const submitPRef = useRef(null)

  const [showPasswordForm, setShowPasswordForm] = useState(false)
  const [passwordFormMessage, setPasswordFormMessage] = useState({
    success: "",
    error: ""
  })

  const [showPersonnalForm, setShowPersonnalForm] = useState(false)
  const [personnalFormMessage, setPersonnalFormMessage] = useState({
    success: "",
    error: ""
  })

  const handleFormSubmit = (data) => {
    let formData = new FormData();
    formData.append('form', JSON.stringify(data))
    formData.append("action", "change_password")

    fetch(process.env.REACT_APP_API_URL + '/index.php',
      {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${user.jwt}`
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          setPasswordFormMessage({ success: t("moncompte_mot_de_passe_mise_a_jour") })
          setShowPasswordForm(false)
        } else {
          setPasswordFormMessage({ error: json.message })
        }
      });
  }

  const handleFormPSubmit = (data) => {
    let formData = new FormData();
    formData.append('form', JSON.stringify(data))
    formData.append("action", "change_personnal_data")

    fetch(process.env.REACT_APP_API_URL + '/index.php',
      {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${user.jwt}`
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          login(json.data.jwt)
          setPasswordFormMessage({ success: t("moncompte_informations_mise_a_jour") })
          setShowPersonnalForm(false)

          setUserData((old) => {
            old.mail = data.mail
            old.telephone = data.telephone

            return old
          })

        } else {
          setPasswordFormMessage({ error: json.message })
        }
      });
  }

  const handleShowPasswordForm = () => {
    reset()
    setShowPasswordForm(true)
  }

  //load user data
  const [userData, setUserData] = useState([])
  useEffect(() => {
    let formData = new FormData();
    formData.append("action", "get_user");

    fetch(process.env.REACT_APP_API_URL + '/index.php',
      {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${user.jwt}`
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.success)
          setUserData(json.data)
      });
  }, []);

  return (
      <div className={"strate"} id={"accountStrate1"}>

        <h1 dangerouslySetInnerHTML={{ __html: t("moncompte_mon_compte") }} />

        <div id={"user_info"} className={"moncompte_block"}>
          <h4>{t("moncompte_informations_personnelles")} <button id={"logout"} className={"cta dark"} onClick={logout}>{t("moncompte_se_deconnecter")}</button></h4>
          <div>
            <label dangerouslySetInnerHTML={{ __html: t("moncompte_nom") }} />
            <span>{userData?.nom}</span>
          </div>
          <div>
            <label dangerouslySetInnerHTML={{ __html: t("moncompte_prenom") }} />
            <span>{userData?.prenom}</span>
          </div>
          <div>
            <label dangerouslySetInnerHTML={{ __html: t("moncompte_telephone") }} />
            <span>{userData?.telephone}</span>
          </div>
          <div>
            <label dangerouslySetInnerHTML={{ __html: t("moncompte_adresse_email") }} />
            <span>{userData?.mail}</span>
          </div>

          {!showPasswordForm && !showPersonnalForm &&
            <div className={"cta_wrapper"} id={"cta_wrapper_show"}>
              <button className={"cta dark"} onClick={() => setShowPersonnalForm(true)} dangerouslySetInnerHTML={{ __html: t("moncompte_modifier_informations_personnelles") }} />
              <button className={"cta dark"} onClick={() => handleShowPasswordForm(true)} dangerouslySetInnerHTML={{ __html: t("moncompte_modifier_mot_de_passe") }} />
            </div>
          }

          {showPasswordForm &&
            <div>
              <form onSubmit={handleSubmit(handleFormSubmit)} id={"form_password"}>
                <CustomFieldText name="password" label={t("moncompte_nouveau_mot_de_passe")} type={"password"}
                  register={register("password", { required: Helper.EmptyErrorMessages.password })}
                  error={errors.password && errors.password.message}
                />
                <CustomFieldText name="password_confirm" label={t("moncompte_confirmation_nouveau_mot_de_passe")} type={"password"}
                  register={register("password_confirm", { required: Helper.EmptyErrorMessages.password })}
                  error={errors.password_confirm && errors.password_confirm.message}
                />
              </form>
              <div id={"error_wrapper"}>
                {passwordFormMessage.error !== "" && passwordFormMessage.error}
              </div>
              <div className={"cta_wrapper"}>
                <button className={"cta dark"} form={"form_password"} dangerouslySetInnerHTML={{ __html: t("moncompte_valider") }} />
                <button className={"cta dark"} onClick={() => setShowPasswordForm(false)} dangerouslySetInnerHTML={{ __html: t("moncompte_annuler") }} />
              </div>
            </div>
          }

          {showPersonnalForm &&
            <div>
              <form onSubmit={handleSubmitP(handleFormPSubmit)} id={"form_personnal"}>
                <CustomFieldText name="telephone" placeholder={t("moncompte_telephone_asterisque")} value={userData?.telephone} register={registerP('telephone', {
                  required: Helper.EmptyErrorMessages.telephone,
                  pattern: { value: Pattern.numberPattern, message: Helper.InvalidErrorMessages.telephone },
                  minLength: { value: 10, message: Helper.InvalidErrorMessages.telephone },
                  maxLength: { value: 10, message: Helper.InvalidErrorMessages.telephone }
                })} error={errorsP.telephone && errorsP.telephone.message} />

                <CustomFieldText name="mail" placeholder={t("moncompte_adresse_email_asterisque")} value={userData?.mail}
                  register={
                    registerP("mail", {
                      required: true,
                      pattern: Pattern.emailPattern,
                      validate: {
                        domain: (value) => Helper.checkMailDomain(value)
                      }
                    })}
                  error={[
                    errorsP.mail && errorsP.mail.type === "required" && Helper.EmptyErrorMessages.mail,
                    errorsP.mail && errorsP.mail.type === "pattern" && Helper.InvalidErrorMessages.mail,
                    errorsP.mail && errorsP.mail.type === "domain" && Helper.InvalidErrorMessages.mail_domain,
                    errorsP.mail && errorsP.mail.type === "confirm" && Helper.InvalidErrorMessages.mail_dif
                  ]} />
              </form>
              <div id={"error_wrapper"}>
                {personnalFormMessage.error !== "" && personnalFormMessage.error}
              </div>
              <div className={"cta_wrapper"}>
                <button className={"cta dark"} form={"form_personnal"} dangerouslySetInnerHTML={{ __html: t("moncompte_valider") }} />
                <button className={"cta dark"} onClick={() => setShowPersonnalForm(false)} dangerouslySetInnerHTML={{ __html: t("moncompte_annuler") }} />
              </div>
            </div>
          }

          <div id={"message_wrapper"}>
            {passwordFormMessage.success !== "" && passwordFormMessage.success || personnalFormMessage.success !== "" && personnalFormMessage.success}
          </div>
        </div>

        <div id={"user_cards"} className={"moncompte_block"}>
          <h4 dangerouslySetInnerHTML={{ __html: t("moncompte_cartes_obtenues") }} />
          {userData.cartes && <ChanceBlock user={userData} />}
          <Carousel indicators={true} loop={true} interval={3000} controls={false}>
            {userData.cartes && Object.entries(userData.cartes)
              .map(([key, card]) => {

                if (card)
                  return (
                    <Carousel.Item>
                      <div className={"carousel_cards"} id={key} />
                    </Carousel.Item>
                  )
                else
                  return (null)


              })}

          </Carousel>
        </div>

      </div>
  )
}

export default MonCompte

/*

       */
